import { getTableForDate } from "../api/scrapeRequests";
import { useState } from "react";
import CardForm from "./cardForm";
import Details from "./details";

export default function FormWrapper() {
    const [actions, setActions] = useState({});
    const shouldRenderDetails = !!(actions['date-of-purchase'] && actions['date-of-selling']);

    const handleAction = (childName, actionDetails) => {
        setActions(prevActions => ({
            ...prevActions,
            [childName]: actionDetails,
        }))};

    return (
        <div>
        <div className="form-wrapper">
            <div>
                <CardForm id="date-of-purchase" dataLoad={loadCurrencyData} calendarText={'purchase'} onAction={(details) => handleAction('date-of-purchase', details)}></CardForm>
            </div>
            <div>
            <div>
                <CardForm id="date-of-selling" dataLoad={loadCurrencyData} calendarText={'sell'} onAction={(details) => handleAction('date-of-selling', details)}></CardForm>
            </div>
            </div>
        </div>
        {shouldRenderDetails ? 
            <Details dateOfPurchase={actions['date-of-purchase']} dateofSelling={actions['date-of-selling']} ></Details>
            :''}
        </div>

    )

    async function loadCurrencyData(date) {

        if (date) {
            const table = await getTableForDate(date);

            if (table) {
                const options = [];

                const tableRows = [...table.querySelectorAll('tbody tr')];
                if (tableRows.length) {
                    tableRows.map((row) => {
                        const tdElements = [...row.querySelectorAll('td.center')];

                        if (tdElements.length) {
                            const text = tdElements[0].textContent;
                            const value = tdElements[1].textContent;
                            options.push({ text, value });
                        }
                    })
                }

                return options;
            }
        }
    }
}







